import { useCallback } from "react";
import { getApiErrorMessage } from "@lending/utils/apiError";
import { useToastsContext } from "./useToasts";

/**
 * Returns a stable `onError` handler that routes API errors through
 * `getApiErrorMessage`: shows the parsed message in a toast when the DRF
 * shape is recognized, falls back to the generic toast otherwise.
 *
 * Designed for use as the `onError` callback on React Query mutations
 * (notably the offer-selection mutations in CreditCard, PersonalLoan, and
 * AutoLoan flows).
 */
function useApiErrorToast(): (error: unknown) => void {
  const { showErrorToast, showGenericErrorToast } = useToastsContext();

  return useCallback(
    (error: unknown) => {
      const message = getApiErrorMessage(error);
      if (message) {
        showErrorToast(message);
      } else {
        showGenericErrorToast();
      }
    },
    [showErrorToast, showGenericErrorToast]
  );
}

export { useApiErrorToast };
